import { Component, AfterViewInit, Input, ChangeDetectorRef, inject, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-webshare',
    templateUrl: './his-display-webshare.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayWebShareComponent implements AfterViewInit {
    private changeDetectorRef = inject(ChangeDetectorRef);

    @Input() title: string;
    @Input() url: string;
    @Input() text: string;
    @Input() btnTitle: string; // title shown as button tool tip

    showShareBtn = true;

    navigator: any = null;

    constructor() {
        this.navigator = window.navigator;
    }

    ngAfterViewInit() {
        // if browser doesn't support Web Share API, don't show button
        if ( this.navigator === null || this.navigator.share === undefined ) {
            this.showShareBtn = false;
        }
        // call change detection to prevent ElementChangeAfterChecked-Error
        this.changeDetectorRef.detectChanges();
    }

    share() {
        // check if browser supports Web Share API
        if ( this.navigator !== null && this.navigator.share !== undefined ) {
            try {
                // call Web Share API
                this.navigator.share( {
                    title: this.title,
                    text: this.text + '\n',
                    url: this.url || window.location.href,
                } ).then( () => { console.log( 'Shared: ' + this.title ); } )
                    .catch( (error: any) => { console.log( error ); } );
            } catch ( error ) {
                console.log( error );
            }
        }
    }
}
